/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
import { featuredWorkflows as featuredWorkflowsDefault } from '@/blocks/featured_workflows_default';
import { defaultWorkflows as strataWorkflows } from '@/blocks/featured_workflows_strata';
import { featuredWorkflowsMooc as featuredWorkflowsMooc } from '@/blocks/featured_workflows_mooc';
import { EBX_ACCESS } from "@/config/constants.js";
import { CONFIG_TYPE } from "@/config/constants.js";

// MOOC organisations get MOOC workflows only
let moocWorkflows = featuredWorkflowsMooc;
// Other organisations get the default set plus the MOOC workflows

let defaultWorkflows = featuredWorkflowsDefault.concat(featuredWorkflowsMooc); 

let strataDefaultWorkflows = strataWorkflows;

/**
 * Get a list of featured workflows for an organisation, based on the OrgConfig.
 */
function getFeaturedWorkflows(orgConfig) {
    if (!orgConfig) {
        console.log("orgConfig is not defined - returning default workflows");
        return defaultWorkflows;
    }
    if (orgConfig.accessType === EBX_ACCESS.MOOC) {
        return moocWorkflows
    }
    
    let orgCustomisation = orgConfig?.getConfig(CONFIG_TYPE.CUSTOMISATION);
    let workflowLibraryType
    if (orgCustomisation) {
        workflowLibraryType = orgCustomisation['workflows.library.name']
    }
    
    // Figure out which set of workflows to return
    switch(workflowLibraryType) {
        case 'strata':
            return strataDefaultWorkflows
        default:
            return defaultWorkflows
    }
}

export {
    getFeaturedWorkflows,
}
